import URI from "urijs";

import {batchReplace, buildQuery, performFetch} from "@main/components/share/functions";

import {
    PAYLOAD_TYPE_JSON,
    RESPONSE_TYPE_JSON
} from "@main/helpers/const";

export class Component {
    /**
     * @param {HTMLElement} container
     * @param {*} data
     */
    constructor(container, data = {}) {
        this.container = container;
        this.data = data;
    }

    async performAction(
        action,
        data = {},
        method = "GET",
        payloadType = PAYLOAD_TYPE_JSON,
        responseType = RESPONSE_TYPE_JSON
    ) {
        let actionName = action;
        let actionVariables = {};

        if (action && Array.isArray(action)) {
            [actionName, actionVariables] = action;
        }

        const baseUrl = this.getActionUrl(actionName, actionVariables);

        let result;

        this.onBeforeAction(actionName, data, method);

        if (method.toUpperCase() === "GET") {
            const uri = new URI(baseUrl);

            result = await performFetch(uri.search(buildQuery(data)).toString());
        } else {
            result = await performFetch(baseUrl, data, "POST", payloadType);
        }

        this.onAfterAction(actionName, data, method);

        if (responseType === RESPONSE_TYPE_JSON) {
            result = await result.json();
        } else {
            result = await result.text();
        }

        return result;
    }

    getActionUrl(action, variables) {
        const {ACTIONS} = this.data;
        let result = {};

        for (const [key, value] of Object.entries(variables)) {
            result[`#${key}#`] = value;
        }

        return batchReplace(ACTIONS[action].URL, result);
    }

    // eslint-disable-next-line no-unused-vars
    onBeforeAction(action, url, data, method) {
    }

    // eslint-disable-next-line no-unused-vars
    onAfterAction(action, url, data, method) {
    }
}
